import { render, staticRenderFns } from "./allsort.vue?vue&type=template&id=c0130cda&scoped=true&"
import script from "./allsort.vue?vue&type=script&lang=js&"
export * from "./allsort.vue?vue&type=script&lang=js&"
import style0 from "./allsort.vue?vue&type=style&index=0&id=c0130cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0130cda",
  null
  
)

export default component.exports